import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BrightBlueFormService {
  private brightBlueFormUsingSubject = new BehaviorSubject<boolean>(false);
  brightBlueFormUsing$ = this.brightBlueFormUsingSubject.asObservable();

  constructor() {}

  setBrightBlueFormStatus(status: boolean): void {
    this.brightBlueFormUsingSubject.next(status);
  }
}
